import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { FormService } from 'src/app/core/util/form.service';

@Component({
  selector: 'app-bir-edit-modal',
  templateUrl: './bir-edit-modal.component.html',
  styles: [
  ],
  standalone: false
})
export class BirEditModalComponent implements OnInit {
  form = this.fb.group({
    code: ['', [Validators.required, Validators.maxLength(20)]],
    tinNumber: ['', [Validators.required, Validators.maxLength(20)]],
    tinBranchCode: ['', [Validators.required, Validators.maxLength(10)]],
    isCompany: [false, []],
    isAR: [false, []],
    isAP: [false, []],
    waCategory: [1, [Validators.required]], // Private=1, Government=2
    classification: [1, [Validators.required]], // Non-Individual=1, Individual=2
    taxpayerType: [0, []],
    companyName: ['', [Validators.maxLength(100)]],
    firstName: ['', [Validators.maxLength(30)]],
    middleName: ['', [Validators.maxLength(30)]],
    lastName: ['', [Validators.maxLength(30)]],
    address: ['', Validators.maxLength(400)],
    district: ['', Validators.maxLength(100)],
    zipCode: ['', Validators.maxLength(10)],
    id: [0, Validators.maxLength(10)],
  });
  isNew = false;
  visible = false;
  body: any = {};

  @Input() forceAR = false;
  @Input() forceAP = false;
  @Input() isGlVoucher = false;

  @Output() readonly selectBir: EventEmitter<any> = new EventEmitter<any>();
  @Output() readonly getBIRId: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private http: _HttpClient,
    private fs: FormService
  ) { }

  ngOnInit(): void {
    return;
  }

  show(data: any) {

    this.form.setErrors(null);
    this.form.patchValue(data);
    if (this.forceAR) this.form.controls.isAR.setValue(true);
    if (this.forceAP) this.form.controls.isAP.setValue(true);
    if (!this.form.controls.tinBranchCode.value) this.form.controls.tinBranchCode.setValue('0000');
    if (!data.id) {
      this.http
        .get('api/BIRClassifications/AutoCode')
        .subscribe(res => {
          this.form.controls.code.setValue(res);
        });
    }

    this.visible = true;
  }

  showNew(data: any) {
    this.form.setErrors(null);
    this.form.patchValue(data);
    if (this.forceAR) this.form.controls.isAR.setValue(true);
    if (this.forceAP) this.form.controls.isAP.setValue(true);
    if (!this.form.controls.tinBranchCode.value) this.form.controls.tinBranchCode.setValue('0000');
    if (!data.id) {
      this.http
        .get('api/BIRClassifications/AutoCode')
        .subscribe(res => {
          this.form.controls.code.setValue(res);
        });
    }

    this.isNew = true;
    this.visible = true;
  }

  handleOk() {
    if (!this.fs.validate(this.form).isValid) return;

    //this.http.post('api/BIRClassifications/create', this.form.value).subscribe();
    this.isNew = false;
    this.visible = false;
    this.selectBir.emit({ ...this.form.value, isUpdate: true } );
  }
}
